import { client, listData } from "./client/graphql";
import { followV2, unfollow as unfollowMutation } from "@/graphql/mutations";
import { isFollowing, listFollowers, listFollowing } from "@/graphql/queries";
import { User } from "@/graphql/schema";

export const follow = async (userId: string) => {
    return client
        .mutate({
            mutation: followV2,
            variables: { input: { userId } },
        })
        .then(({ data }) => data.followV2);
};

export const unfollow = async (userId: string) => {
    return client
        .mutate({
            mutation: unfollowMutation,
            variables: { input: { userId } },
        })
        .then(({ data }) => data.unfollow);
};

export const callListFollowing = async ({
    userId,
    extraDetails = false,
}: {
    userId: string;
    extraDetails?: boolean;
}) => {
    return (await listData({
        listQuery: listFollowing,
        input: { userId, extraDetails },
        queryName: "listFollowing",
    })) as User[];
};

export const callListFollowers = async ({
    userId,
    extraDetails = false,
}: {
    userId: string;
    extraDetails?: boolean;
}) => {
    return (await listData({
        listQuery: listFollowers,
        input: { userId, extraDetails },
        queryName: "listFollowers",
    })) as User[];
};

export const isFollowingUser = async (userId: string) => {
    return await client
        .query({
            query: isFollowing,
            variables: { input: { userId } },
        })
        .then(data => !!data.data.isFollowing)
        .catch(() => false);
};
